<div *ngIf="solution.IsRemoved" class="text-smp spacer-md alert alert-success GsAlert" khA11yAlert="status">
  <fa-icon [icon]="['fas','check']" class="light-green"></fa-icon>
  {{ 'SOLUTION_DISPLAY.IMAGE_DELETED' | translate }}
</div>

<div class="solution-container solution-container--{{layoutClass}}" *ngIf="!solution.IsRemoved">
  <div *ngIf="!solution.IsRemoved">
    <h3 *ngIf="showStudentName && solution.Student">
      {{solution.Student.FirstName}} {{solution.Student.LastName}}
    </h3>

    <img class="solution__image" [src]="url" *ngIf="url" alt="">

    <div *ngIf="solution.Explanation && !hideExtras" class="solution__explanation" [class.solution__explanation--no-image]="!solution.SolutionFileId">
      <pre><b>{{ 'SOLUTION_DISPLAY.EXPLANATION' | translate }}</b> <fa-icon [icon]="['fas', 'angle-right']"></fa-icon>
        {{solution.Explanation}}</pre>
    </div>

    <!-- Feedback -->
    <div *ngIf="showFeedback && !hideExtras" class="solution-feedback solution-feedback__comments animate-show">
      <b *ngIf="showFeedback">{{ 'SOLUTION_DISPLAY.FEEDBACK' | translate }}</b>
      <div class="float-right">
        <a *ngIf="showFeedback" class="cursor ul text-sm" (click)="toggleShowFeedback()">{{ 'SOLUTION_DISPLAY.HIDE' | translate }}</a>
      </div>
      <div class="left" *ngIf="showFeedback">
        <div *ngIf="!editing" class="PortfolioFeedbackText">
            <kh-inner-html-container [content]="solution.TeacherComments"></kh-inner-html-container>
        </div>
        <ng-container *ngIf="tinymceLiteOptions.folder; else needPath">
          <kh-input-text-editor *ngIf="editing" [(questionText)]="solution.TeacherComments" [imagePath]="tinymceLiteOptions.folder"></kh-input-text-editor>
        </ng-container>
        <ng-template #needPath>{{ 'SOLUTION_DISPLAY.IMAGEPATH_IS_REQUIRED' | translate }}</ng-template>
      </div>
    </div>

    <!-- Like/favourite -->
    <div class="solution-feedback solution-feedback__favbar" *ngIf="!hideActions">
      <div class="d-flex justify-content-between align-items-center">
        <div *ngIf="!hideExtras" class="solution-feedback__feedback-buttons">
          <a *ngIf="!showFeedback && solution.TeacherComments" class="btn btn-primary" (click)="showFeedback = true">
            {{ 'SOLUTION_DISPLAY.SHOW_FEEDBACK_1' | translate }} <!-- change to counter after implementing threads -->
          </a>
          <button *ngIf="showFeedback && editing" class="btn btn-info" (click)="saveComment(solution); editing = false;">
            <fa-icon [icon]="['fas', 'check']"></fa-icon>&nbsp;{{ 'SOLUTION_DISPLAY.SAVE' | translate }}
          </button>
          <button class="btn btn-primary mr-kh-2" (click)="editing = true; showFeedback = true" *ngIf="!showFeedback && !editing && !solution.TeacherComments">
            <fa-icon [icon]="['fas','comment-alt']"></fa-icon>
            <span>&nbsp;{{ 'SOLUTION_DISPLAY.GIVE_FEEDBACK' | translate }}</span>
          </button>
          <button class="btn btn-primary" (click)="editing = true" *ngIf="showFeedback && !editing">
            <fa-icon [icon]="['fas','comment-alt']"></fa-icon>
            <span *ngIf="solution.TeacherComments">&nbsp;{{ 'SOLUTION_DISPLAY.UPDATE_FEEDBACK' | translate }}</span>
            <span *ngIf="!solution.TeacherComments">&nbsp;{{ 'SOLUTION_DISPLAY.GIVE_FEEDBACK' | translate }}</span>
          </button>
        </div>
        <div class="d-flex justify-content-between align-items-center flex-wrap">
          <a [tooltip]="'SOLUTION_DISPLAY.ROTATE' | translate" class="cursor portfolio-feedback-toolbar__icon portfolio-feedback-toolbar__icon-rotate" (click)="rotateSolution(solution)">
            <fa-icon [icon]="['fas','redo-alt']"></fa-icon>
          </a>
          <a [tooltip]="'SOLUTION_DISPLAY.VIEW_FULLSCREEN' | translate" class="cursor portfolio-feedback-toolbar__icon portfolio-feedback-toolbar__icon-enlarge" (click)="expandImage()">
            <fa-icon [icon]="['fas','search-plus']"></fa-icon>
          </a>
          <div class="inline-block relative">
            <a class="cursor portfolio-feedback-toolbar__icon portfolio-feedback-toolbar__icon-delete" [popover]="deleteItemPopover" containerClass="kh-popover-container kh-white-popover" placement="top" triggers="" [isOpen]="showDeletePopover" (click)="showDeletePopover = true">
              <fa-icon [icon]="['fas','trash-alt']"></fa-icon>
            </a>
          </div>
          <a class="cursor portfolio-feedback-toolbar__icon portfolio-feedback-toolbar__icon-favourite" (click)="toggleFavourite(solution)" [tooltip]="'SOLUTION_DISPLAY.SAVE_AS_A_FAVOURITE_SOLUTION' | translate">
            <fa-icon [icon]="['fas', 'heart']" [class.grey]="!solution.IsMyFavouriteNo" [class.pink]="solution.IsMyFavouriteNo"></fa-icon>
          </a>
          <a *ngIf="!hideExtras" class="cursor portfolio-feedback-toolbar__icon portfolio-feedback-toolbar__icon-like" [class.grey]="!solution.IsLiked" (click)="toggleLike(solution)" [tooltip]="'SOLUTION_DISPLAY.LIKE_THIS_SOLUTION' | translate">
            <fa-icon [icon]="['fas', 'thumbs-up']"></fa-icon>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #deleteItemPopover>
  <div class="popover top TourTips animate-show portfolio-component-delete-popover" khA11yAlert="status">
    <div class="arrow"></div>
    <div class="popover-content no-bold">
      <b>{{ 'SOLUTION_DISPLAY.DELETE_IMAGE' | translate }}</b><br>
      <div class="d-flex flex-nowrap">
        <button class="btn btn-sm btn-danger mr-kh-2" (click)="delete(solution)">{{ 'SOLUTION_DISPLAY.DELETE' | translate }}</button>
        <button class="btn btn-sm btn-default" (click)="showDeletePopover = false">{{ 'SOLUTION_DISPLAY.CANCEL' | translate }}</button>
      </div>
    </div>
  </div>
</ng-template>
